import clsx from 'clsx'
import { styled } from '@mui/material'
import { Loading } from '$common/loading/chat-loading'

const Root = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;

  width: fit-content;
  box-sizing: border-box;
  padding: 15px 30px;

  border-radius: 24px;
  background-color: #0000004d;

  &.overlay {
    height: 29px;
    padding: 8px 30px;

    position: absolute;
    top: 15px;
    left: 50%;
    transform: translateX(-50%);

    &.bottom {
      top: auto;
      bottom: 15px;
    }
  }
`

export function MessageListLoading({
  offset,
  isOverlay,
  overlayPosition = 'top',
}: {
  offset?: number
  isOverlay?: boolean
  overlayPosition?: 'top' | 'bottom'
}) {
  return (
    <Root
      sx={{ margin: `${isOverlay ? 16 + (offset || 0) : 0}px auto` }}
      className={clsx({
        overlay: isOverlay,
        [overlayPosition]: true,
      })}
    >
      <Loading color="white" />
    </Root>
  )
}

MessageListLoading.defaultProps = { isInline: false, offset: 0, edge: false }
